@if (explanation(); as sentence) {
	<p class="text-base-content/60 mb-2 text-sm">{{ sentence }}</p>
}
<div class="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
	<label class="block min-w-0">
		<span class="text-base-content/60 mb-1 block text-xs font-medium" [translate]>Country</span>
		<select
			class="select select-bordered select-sm w-full min-w-0"
			data-testid="billing-country"
			[disabled]="disabled()"
			[ngModel]="valueOf('country')"
			(ngModelChange)="setField('country', $event)"
			name="country"
		>
			<option value="" [translate]>Choose a country…</option>
			@for (country of countries; track country.code) {
				<option [value]="country.code">{{ country.label }} ({{ country.code }})</option>
			}
		</select>
	</label>
	@for (field of fields; track field.key) {
		<label class="block min-w-0">
			<span class="text-base-content/60 mb-1 block text-xs font-medium" [translate]>{{ field.label }}</span>
			<input
				class="input input-bordered input-sm w-full min-w-0"
				[type]="field.type"
				[attr.data-testid]="'billing-' + field.key"
				[disabled]="disabled()"
				[ngModel]="valueOf(field.key)"
				(ngModelChange)="setField(field.key, $event)"
				[name]="field.key"
			/>
		</label>
	}
</div>
@if (baseCurrency(); as issuedIn) {
	<div class="mt-3">
		<label class="block min-w-0 sm:max-w-xs">
			<span class="text-base-content/60 mb-1 block text-xs font-medium" [translate]>Also show the total in another currency (optional)</span>
			<select
				class="select select-bordered select-sm w-full min-w-0"
				data-testid="billing-indicative-currency"
				[disabled]="disabled()"
				[ngModel]="indicativeCurrency() ?? ''"
				(ngModelChange)="indicativeCurrency.set($event || null)"
				name="indicativeCurrency"
			>
				<option value="" [translate]>No second currency</option>
				@for (currency of indicativeCurrencies; track currency.code) {
					<option [value]="currency.code">{{ currency.label }} ({{ currency.code }})</option>
				}
			</select>
		</label>
		<p class="text-base-content/60 mt-1 text-xs">
			<span [translate]>An indication only, converted at the European Central Bank's reference rate of the day and printed beside the total. Invoices are issued, and payments are only accepted, in</span>
			<span class="ml-1 font-medium">{{ issuedIn }}</span
			><span>.</span>
			<span [translate]>Your bank will use its own rate, so the amount you are actually charged will differ.</span>
		</p>
	</div>
}
